module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "v-upload-select",
    class: {
      'v-upload-dragger': _vm.type === 'drag', 'is-dragOver': _vm.dragover && !_vm.disabled, 'v-upload-image-list': _vm.type === 'imageList'
    },
    on: {
      "drop": function($event) {
        $event.preventDefault();
        _vm.fileChange($event)
      },
      "dragover": function($event) {
        $event.preventDefault();
        _vm.dragover = true
      },
      "dragleave": function($event) {
        $event.preventDefault();
        _vm.dragover = false
      }
    }
  }, [(_vm.type === 'fileList') ? _c('div', [_c('button', {
    staticClass: "btn btn-sm btn-primary",
    class: {
      'v-select-btn': !_vm.isAuto
    },
    attrs: {
      "type": "button",
      "disabled": _vm.disabled
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.selectItem($event)
      }
    }
  }, [_vm._v("选择文件\n        ")]), _vm._v(" "), (!_vm.isAuto) ? _c('button', {
    staticClass: "btn btn-sm btn-primary",
    class: {
      'v-upload-btn': !_vm.isAuto
    },
    attrs: {
      "type": "button",
      "disabled": _vm.disabled
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.confirmUpload($event)
      }
    }
  }, [_vm._v("确定上传\n        ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.type === 'drag') ? _c('div', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.selectItem($event)
      }
    }
  }, [_c('div', {
    staticClass: "v-icon-cloud-upload",
    class: {
      'v-upload-disable': _vm.disabled === true
    }
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": "512",
      "height": "512",
      "viewBox": "0 0 512 512"
    }
  }, [_c('g', {
    attrs: {
      "id": "icomoon-ignore"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M446.134 193.245c1.222-5.555 1.866-11.324 1.866-17.245 0-44.183-35.817-80-80-80-7.111 0-14.007 0.934-20.566 2.676-12.399-38.676-48.645-66.676-91.434-66.676-43.674 0-80.527 29.168-92.163 69.085-11.371-3.311-23.396-5.085-35.837-5.085-70.692 0-128 57.308-128 128 0 70.694 57.308 128 128 128h64v96h128v-96h112c44.183 0 80-35.816 80-80 0-39.36-28.427-72.081-65.866-78.755zM288 320v96h-64v-96h-80l112-112 112 112h-80z",
      "fill": "#99a9bf"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "v-upload-text"
  }, [_vm._v("将文件拖拽到此处或者点击上传")]), _vm._v(" "), (_vm.lastestFile.percentage === 100) ? _c('img', {
    attrs: {
      "src": _vm.lastestFile.url
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lastestFile.percentage === 100),
      expression: "lastestFile.percentage === 100"
    }],
    staticClass: "v-upload-modal"
  }, [_c('span', {
    staticClass: "btn",
    class: {
      'v-upload-disable': _vm.disabled === true
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.deleteFile($event)
      }
    }
  }, [_c('i', [_c('svg', {
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": "512",
      "height": "512",
      "viewBox": "0 0 512 512"
    }
  }, [_c('g', {
    attrs: {
      "id": "icomoon-ignore"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64 160v320c0 17.6 14.4 32 32 32h288c17.6 0 32-14.4 32-32v-320h-352zM160 448h-32v-224h32v224zM224 448h-32v-224h32v224zM288 448h-32v-224h32v224zM352 448h-32v-224h32v224z",
      "fill": "#fff"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M424 64h-104v-40c0-13.2-10.8-24-24-24h-112c-13.2 0-24 10.8-24 24v40h-104c-13.2 0-24 10.8-24 24v40h416v-40c0-13.2-10.8-24-24-24zM288 64h-96v-31.599h96v31.599z",
      "fill": "#fff"
    }
  })])])]), _vm._v(" "), _c('span', {
    staticClass: "btn",
    class: {
      'v-upload-disable': _vm.disabled === true
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.selectItem($event)
      }
    }
  }, [_c('i', {
    staticClass: "v-icon-upload-continue"
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": "512",
      "height": "512",
      "viewBox": "0 0 512 512"
    }
  }, [_c('g', {
    attrs: {
      "id": "icomoon-ignore"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0 448h512v32h-512zM512 384v32h-512v-32l64-128h128v64h128v-64h128zM112 160l144-144 144 144h-112v128h-64v-128z",
      "fill": "#fff"
    }
  })])])])])]) : _vm._e(), _vm._v(" "), (_vm.type === 'imageList') ? _c('div', [_c('ul', _vm._l((_vm.fileList), function(file, index) {
    return _c('li', {
      staticClass: "v-upload-img"
    }, [_c('v-popover', {
      ref: "popover",
      refInFor: true,
      attrs: {
        "placement": "top"
      }
    }, [_c('img', {
      staticStyle: {
        "width": "440px"
      },
      attrs: {
        "src": file.url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "v-upload-img",
      slot: "reference"
    }, [(file.percentage === 100) ? _c('img', {
      attrs: {
        "src": file.url
      }
    }) : _vm._e(), _vm._v(" "), (file.showProgress && _vm.showProgress) ? _c('v-progress', {
      staticClass: "circle-progress",
      attrs: {
        "width": 100,
        "type": "circle",
        "stroke-width": 4.8,
        "percentage": file.percentage,
        "status": file.percentage === 100 ? 'success' : ''
      }
    }) : _vm._e(), _vm._v(" "), (_vm.enableHeadImage && index === 0) ? _c('div', {
      staticClass: "headImageTag"
    }, [_vm._v("首图")]) : _vm._e(), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (file.percentage === 100),
        expression: "file.percentage === 100"
      }],
      staticClass: "v-upload-modal"
    }, [_c('div', {
      staticStyle: {
        "width": "100%",
        "bottom": "0",
        "height": "30px",
        "background-color": "#06c1ae",
        "position": "absolute"
      }
    }, [_c('a', {
      staticClass: "imageOperator",
      class: {
        'v-upload-disable': _vm.disabled === true
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.deleteFile(file)
        }
      }
    }, [_vm._v("删除")]), _vm._v(" "), (_vm.enableHeadImage && index !== 0) ? _c('a', {
      staticClass: "imageOperator",
      class: {
        'v-upload-disable': _vm.disabled === true
      },
      staticStyle: {
        "float": "right"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.setHeadImage(file)
        }
      }
    }, [_vm._v("设为首图")]) : _vm._e()])])], 1)])], 1)
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fileList.length < _vm.maxLimit),
      expression: "fileList.length < maxLimit"
    }],
    staticClass: "v-upload-add plus",
    class: {
      'v-upload-disable': _vm.disabled === true
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.selectItem($event)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('input', {
    ref: "input",
    staticClass: "v-upload-input",
    attrs: {
      "type": "file",
      "multiple": _vm.isMultiple,
      "accept": _vm.accept,
      "disabled": _vm.disabled
    },
    on: {
      "change": _vm.fileChange
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e913ab3","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/custom-upload/upload-select.vue
// module id = 525
// module chunks = 0